<template>
    <div>
        <div class="col-12">
            <h2 class="color-h2-project font-weight-bold mb-3">
                Un proyecto único
            </h2>
            <div id="description_section" class="overview-content text-justify">
                <span v-html="description"></span>
            </div>
        </div>
        <div class="col-12" v-if="
            project.exercise_area ||
            project.green_area ||
            project.bikers ||
            project.games_accessibility ||
            project.calisthenics_area ||
            project.stores ||
            project.events_room ||
            project.clean_points ||
            project.elevators ||
            project.controlled_access ||
            project.quincho ||
            project.swimming_pool ||
            project.hospital ||
            project.subway_station ||
            project.community_center ||
            project.kindergarten ||
            project.multi_court
        ">
            <h2 class="mb-3 color-h2-project font-weight-bold">
                Lo que este hogar te ofrece
            </h2>
            <div id="description_section2" class="overview-content">
                <div class="mt-1 d-flex align-items-center" v-if="project.exercise_area">
                    <img src="../../../assets/images/atracciones/gym.svg" class="icon-atraction" />
                    <span class="ml-2">Áreas de ejercicios</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.green_area">
                    <img src="../../../assets/images/atracciones/area_verde.svg" class="icon-atraction" />
                    <span class="ml-2">Áreas verdes</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.bikers">
                    <img src="../../../assets/images/atracciones/bicicleteros.svg" class="icon-atraction" />
                    <span class="ml-2">Bicicleteros</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.games_accessibility">
                    <img src="../../../assets/images/atracciones/juegos_infantiles.svg" class="icon-atraction" />
                    <span class="ml-2">Plaza de juegos infantiles</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.calisthenics_area">
                    <img src="../../../assets/images/atracciones/gym.svg" class="icon-atraction" />
                    <span class="ml-2">Áreas de calistenia</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.stores">
                    <img src="../../../assets/images/atracciones/minimarket.svg" class="icon-atraction" />
                    <span class="ml-2">Locales comerciales</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.events_room">
                    <img src="../../../assets/images/atracciones/sala_multiuso.svg" class="icon-atraction" />
                    <span class="ml-2">Sala multiuso</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.clean_points">
                    <img src="../../../assets/images/atracciones/punto_limpio.svg" class="icon-atraction" />
                    <span class="ml-2">Puntos limpios</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.elevators">
                    <img src="../../../assets/images/atracciones/asensores.svg" class="icon-atraction" />
                    <span class="ml-2">Ascensores</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.controlled_access">
                    <img src="../../../assets/images/atracciones/acceso_controlado.svg" class="icon-atraction" />
                    <span class="ml-2">Acceso controlado</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.quincho">
                    <img src="../../../assets/images/atracciones/quincho.svg" class="icon-atraction" />
                    <span class="ml-2">Quincho</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.swimming_pool">
                    <img src="../../../assets/images/atracciones/piscina.svg" class="icon-atraction" />
                    <span class="ml-2">Piscina</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.hospital">
                    <img src="../../../assets/images/atracciones/hospital.svg" class="icon-atraction" />
                    <span class="ml-2">Cercano a Hospitales</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.subway_station">
                    <img src="../../../assets/images/atracciones/estacion_metro.svg" class="icon-atraction" />
                    <span class="ml-2">A pasos de estación de metro</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.community_center">
                    <img src="../../../assets/images/atracciones/centro_comunitario.svg" class="icon-atraction" />
                    <span class="ml-2">Centro comunitario</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.kindergarten">
                    <img src="../../../assets/images/atracciones/juegos_infantiles.svg" class="icon-atraction" />
                    <span class="ml-2">Juegos infantiles</span>
                </div>
                <div class="mt-1 d-flex align-items-center" v-if="project.multi_court">
                    <img src="../../../assets/images/atracciones/multi_cancha.svg" class="icon-atraction" />
                    <span class="ml-2">Multi cancha</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeaturesSection',
    props: {
        description: '',
        project: ''
    },
    data: () => ({}),
    mounted() { },
    methods: {}
}
</script>

<style scoped>
.icon-atraction {
    width: 1.1rem;
}
</style>
